import {ExcludeCondition} from 'graphql-client/declarative-translations/RESTExcludeConditions';

import {TranslatableValue} from './DeclarativeTranslator';

/**
 * BaseFieldTranslator is an abstract class for field translations between REST and GraphQL.
 */
export default abstract class BaseFieldTranslator {
  public restKey: string;
  public graphQLKey: string;
  public excludeCondition: ExcludeCondition | null;

  constructor(restKey: string, graphQLKey: string, excludeCondition: ExcludeCondition | null) {
    this.restKey = restKey;
    this.graphQLKey = graphQLKey;
    this.excludeCondition = excludeCondition;
  }

  // Classes should also implement the following, though it's not included on the abstract class because of
  // https://github.com/microsoft/TypeScript/issues/34516
  //
  //   public static tryParse(
  //     parsedRESTField: RESTField,
  //     graphQLSelectionSet: GraphQLSelectionSet,
  //     possibleTypesMapping: PossibleTypesMapping
  //   ): BaseFieldTranslator | null;

  public abstract getGQLValue(restObj: TranslatableValue): unknown;

  public abstract getRESTValue(gqlObj: TranslatableValue): unknown;
}
